<template>
  <AsyncVuePhoneNumberInput
    v-model="phoneNumber"
    color="lightgrey"
    :dark="dark"
    :disabled="disabled"
    :ignored-countries="countriesIgnored"
    :preferred-countries="countriesList"
    :loader="hasLoaderActive"
    :default-country-code="defaultCountryCode"
    clearable
    :error="hasErrorActive"
    :translations="translations"
    autofocus
    @update="handleUpdate"
    @enterKeypress="handleEmitEnterKeyPress"
  />
</template>

<script>
  const AsyncVuePhoneNumberInput = async () => {
    const component = await import(
      /* webpackChunkName: "phone-number-input" */ './vue-phone-number-input/VuePhoneNumberInput'
    )
    return component.default
  }

  export default {
    components: {
      AsyncVuePhoneNumberInput
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        phoneNumber: null,
        countriesList: ['BR', 'US', 'DE'],
        defaultCountryCode: 'BR',
        countriesIgnored: ['AF', 'AD', 'AL'],
        translations: {
          countrySelectorLabel: this.$t('numberInput.countrySelectorLabel'),
          countrySelectorError: this.$t('numberInput.countrySelectorError'),
          phoneNumberLabel: this.$t('numberInput.phoneNumberLabel'),
          example: this.$t('numberInput.example')
        },
        dark: false,
        hasLoaderActive: false,
        hasErrorActive: false,
        isValid: false
      }
    },
    methods: {
      handleUpdate(updatedValue) {
        this.$emit('input', updatedValue)

        this.isValid = updatedValue.isValid
      },
      handleEmitEnterKeyPress() {
        this.$emit('enterKeypress', { isValid: this.isValid })
      }
    }
  }
</script>

<style></style>
